var YBRequest = require('../request')
var Transform = require('./transform')
var Log = require('../../log')
var Util = require('../../util')
var Constants = require('../../constants')

var ViewTransform = Transform.extend(
  /** @lends ViewTransform.prototype */
  {
    /**
     * This class manages Fastdata service and view index.
     *
     * @constructs
     * @extends Transform
     * @memberof youbora
     *
     * @param {Plugin} plugin Instance of {@link Plugin}
     */
    constructor: function (plugin) {
      Transform.prototype.constructor.apply(this, arguments)

      /** /data response */
      this.response = {}

      this._viewIndex = -1

      var service = Constants.Service.DATA
      var params = {
        apiVersion: 'v6,v7',
        outputformat: 'jsonp'
      }

      params = plugin.requestBuilder.buildParams(params, service)
      if (params !== null) {
        Log.notice(service + ' ' + params.system)
        if (params.system === 'nicetest') {
          Log.error(
            'No accountCode has been set. Please set your accountCode inside plugin\'s options.'
          )
        }

        this._request = new YBRequest(plugin.getHost(), service, params)
      }
    },

    /**
     * Sends initial request
     */
    init: function () {
      this._request
        .on(YBRequest.Event.SUCCESS, this._receiveData.bind(this))
        .on(YBRequest.Event.ERROR, this._failedData.bind(this))
        .send()
    },

    _receiveData: function (req, e) {
      try {
        var msg = req.getXHR().response
        var resp = JSON.parse(msg.slice(msg.indexOf('(') + 1, msg.lastIndexOf(')')))

        this.response.host = Util.addProtocol(resp.q.h)
        this.response.code = resp.q.c
        this.response.pingTime = resp.q.pt

        this.done()
      } catch (err) {
        Log.error('Fastdata response is invalid.')
      }
    },

    _failedData: function (req, e) {
      Log.error('Fastdata request failed.')
    },

    /**
     * Call this method when a new content begins, it will increment the view index (_0, _1, _2...)
     * @return {string} new viewcode
     */
    nextView: function () {
      this._viewIndex += 1
      return this.getViewCode()
    },

    /**
     * Returns current viewcode
     * @return {string} viewcode
     */
    getViewCode: function () {
      return this.response.code + '_' + this._viewIndex
    },

    /**
     * Transform requests
     * @param {youbora.comm.YBRequest} request YBRequest to transform.
     */
    parse: function (request) {
      request.host = request.host || this.response.host
      request.params.code = request.params.code || this.getViewCode()
      if (request.service === Constants.Service.PING ||
        request.service === Constants.Service.START) {
        request.params.pingTime = request.params.pingTime || this.response.pingTime
      }
    }
  })

module.exports = ViewTransform



//////////////////
// WEBPACK FOOTER
// ./src/comm/transform/view.js
// module id = 17
// module chunks = 0